import { Text } from '@mantine/core';
import React from 'react';

function XInfoTabTitle(props: { label: string; dataCy?: string }) {
  const { label, dataCy } = props;
  return (
    <>
      <Text size='xl' weight={700} data-cy={dataCy} py='sm'>
        {label}
      </Text>
    </>
  );
}

export default XInfoTabTitle;
